module.exports = __webpack_public_path__ + "static/3-bd454fd139f86901dc9314254338a7a8.jpg";